'use client';

import { __styles, mergeClasses } from '@griffel/react';
import { tokens } from '@fluentui/react-theme';
import { useColorSliderStyles_unstable } from '../ColorSlider/useColorSliderStyles.styles';
const TRANSPARENT_IMAGE_URL = 'https://fabricweb.azureedge.net/fabric-website/assets/images/transparent-pattern.png';
export const alphaSliderClassNames = {
  root: 'fui-AlphaSlider',
  rail: 'fui-AlphaSlider__rail',
  thumb: 'fui-AlphaSlider__thumb',
  input: 'fui-AlphaSlider__input'
};
export const alphaSliderCSSVars = {
  sliderDirectionVar: `--fui-AlphaSlider--direction`,
  sliderProgressVar: `--fui-AlphaSlider--progress`,
  thumbColorVar: `--fui-AlphaSlider__thumb--color`,
  railColorVar: `--fui-AlphaSlider__rail--color`
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  rail: {
    Bgfg5da: 0,
    B9xav0g: 0,
    oivjwe: 0,
    Bn0qgzm: 0,
    B4g9neb: 0,
    zhjwy3: 0,
    wvpqe5: 0,
    ibv6hh: 0,
    u1mtju: 0,
    h3c5rm: 0,
    vrafjx: 0,
    Bekrc4i: 0,
    i8vvqc: 0,
    g2u3we: 0,
    icvyot: 0,
    B4j52fo: 0,
    irswps: "fm9niy",
    Bcmaq0h: "f183gti0"
  }
}, {
  d: [[".fm9niy{border:1px solid var(--colorNeutralStroke1);}", {
    p: -2
  }], `.f183gti0{background-image:linear-gradient(var(--fui-AlphaSlider--direction), transparent, var(--fui-AlphaSlider__rail--color)),url(https://fabricweb.azureedge.net/fabric-website/assets/images/transparent-pattern.png);}`]
});
/**
 * Styles for the thumb slot
 */
const useThumbStyles = /*#__PURE__*/__styles({
  thumb: {
    De3pzq: "fxugw4r",
    cmx5o7: "f5vbyc6"
  },
  horizontal: {
    Bz10aip: ["f13gfj74", "f1nfknbn"],
    oyh7mz: ["fsmxtey", "fh8h8tc"]
  },
  vertical: {
    Bz10aip: "f5cv5a3",
    B5kzvoi: "falo4kr"
  }
}, {
  d: [".fxugw4r{background-color:var(--colorNeutralBackground1);}", ".f5vbyc6::before{background-color:var(--fui-AlphaSlider__thumb--color);}", ".f13gfj74{transform:translateX(-50%);}", ".f1nfknbn{transform:translateX(50%);}", ".fsmxtey{left:var(--fui-AlphaSlider--progress);}", ".fh8h8tc{right:var(--fui-AlphaSlider--progress);}", ".f5cv5a3{transform:translateY(50%);}", ".falo4kr{bottom:var(--fui-AlphaSlider--progress);}"]
});
/**
 * Apply styling to the AlphaSlider slots based on the state
 */
export const useAlphaSliderStyles_unstable = state => {
  'use no memo';

  const styles = useStyles();
  const thumbStyles = useThumbStyles();
  state.root.className = mergeClasses(alphaSliderClassNames.root, state.root.className);
  state.input.className = mergeClasses(alphaSliderClassNames.input, state.input.className);
  state.rail.className = mergeClasses(alphaSliderClassNames.rail, styles.rail, state.rail.className);
  state.thumb.className = mergeClasses(alphaSliderClassNames.thumb, thumbStyles.thumb, state.vertical ? thumbStyles.vertical : thumbStyles.horizontal, state.thumb.className);
  state.thumb.className = mergeClasses(alphaSliderClassNames.thumb, thumbStyles.thumb, state.vertical ? thumbStyles.vertical : thumbStyles.horizontal, state.thumb.className);
  useColorSliderStyles_unstable(state);
  return state;
};